export const isMobileDevice = (onlySmartphone = false): boolean => {
  if (onlySmartphone) {
    return window.matchMedia('only screen and (max-width: 480px)').matches;
  }

  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1 ||
    navigator.userAgent.indexOf('Mobile') !== -1
  );
};
